export default {
	correctLines: '{count} ligne correcte | {count} lignes correctes',
	warningLines: '{count} ligne recevable | {count} lignes recevables',
	warningLinesHelp: 'Ces lignes comportent des données d’identification patient non trouvées' +
		' dans nos référentiels.<br/>' +
		'Nous vous conseillons de vérifier ces données selon le type d’erreur indiqué' +
		' (NIR KO ou Date de naissance / Rang KO).<br/>' +
		'Si toutefois ces données sont correctes selon vous, vous pouvez valider l’import' +
		' et des contrôles seront effectués ultérieurement.<br/>' +
		'Si ces données ne sont pas retrouvées, elles ne seront pas prises en compte' +
		' ni pour l’évaluation ni pour les rémunérations.',
	incorrectLines: '{count} ligne incorrecte | {count} lignes incorrectes',
	correctEmails: '{count} email correct | {count} emails corrects',
	incorrectEmails: '{count} email incorrect | {count} emails incorrects'
};
